module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.applications) ? _c('v-list', _vm._l((_vm.applications), function(app) {
    return _c('v-list-tile', {
      key: app.id,
      attrs: {
        "to": {
          path: app.path
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.updateParentTitle(app.name)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(app.name))])], 1)], 1)
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3fd24e4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fd24e4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/leftnav/leftnav.vue.html
// module id = 586
// module chunks = 0